import { ReactComponent as BarChartIcon } from './bar_chart.svg'
import { ReactComponent as CalendarIcon } from './calendar.svg'
import { ReactComponent as CircleIcon } from './circle.svg'
import { ReactComponent as FileIcon } from './file.svg'
import { ReactComponent as LineChartIcon } from './line_chart.svg'
import { ReactComponent as NoteIcon } from './note.svg'
import { ReactComponent as NotePanelIcon } from './note_panel.svg'
import { ReactComponent as SunIcon } from './sun.svg'
import { ReactComponent as VideoIcon } from './video.svg'

const icons = {
  BarChartIcon,
  CalendarIcon: CalendarIcon,
  CircleIcon: CircleIcon,
  LineChartIcon: LineChartIcon,
  NoteIcon: NoteIcon,
  NotePanelIcon: NotePanelIcon,
  SunIcon: SunIcon,
  VideoIcon: VideoIcon,
  FileIcon: FileIcon,
}
export default icons
